module.exports = __webpack_public_path__ + "public/img/Mengelola Dokumen untuk Staf Perkantoran.cef3cdec.png";